import { DualListBoxItem } from '../../../../../DualListBox';
import useStore from '../../../../../Hooks/useStore';
import * as S from './Styles';

type SelectedItemMaskProps = FilteredProductItem & {
  hover?: boolean;
  selectedItems: DualListBoxItem[];
  markedSelectedItems: DualListBoxItem[];
};
const SelectedItemMask = ({
  hover = false,
  ...product
}: SelectedItemMaskProps) => {
  const { id, type, ean, resume, code } = product;
  const [getters, setters] = useStore();
  const {
    ticket: { getTicket },
  } = getters;
  const {
    ticket: { setTicket },
  } = setters;
  const pinnedProducts = getTicket('form.batch.pinnedProducts');

  const isPinned = !!pinnedProducts.find(
    ({ id: i, type: t }) => i === id && t === type,
  );

  const pinProduct = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setTicket(
      'form.batch.pinnedProducts',
      pinnedProducts.find(({ id: i, type: t }) => i === id && t === type)
        ? pinnedProducts.filter(
            ({ id: i, type: t }) => !(i === id && t === type),
          )
        : [product, ...pinnedProducts],
    );
  };

  return (
    <S.SelectedItemMaskContainer pinned={isPinned} hover={hover}>
      <S.SelectedItemMaskLabel>
        {`${ean} - ${resume} - ${code}`}
      </S.SelectedItemMaskLabel>
      <S.SelectedItemMaskControlContainer>
        <S.SelectedItemMaskControl
          pinned={isPinned}
          hover={hover}
          onClick={pinProduct}
          emptyList={pinnedProducts.length === 0}
        >
          <S.SelectedItemMaskControlIcon pinned={isPinned} hover={hover} />
        </S.SelectedItemMaskControl>
      </S.SelectedItemMaskControlContainer>
    </S.SelectedItemMaskContainer>
  );
};

export default SelectedItemMask;
